/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

get({ searchKey, conversationId } = {}) {
  const params = {};

  if (searchKey) {
    params.search = searchKey;
  }

  if (conversationId) {
    params.conversation_id = conversationId;
  }

  return axios.get(this.url, { params });
}
}

export default new CannedResponse();
